import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { RadiantStar } from './ui/RadiantStar';
export function HeroSection() {
  const phrases = ['Partnership-based,', 'clarity-focused coaching', 'for confident decisions', 'and new adventures.'];
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-50">
      {/* Background with gradient and texture */}
      <div className="absolute inset-0 bg-gradient-to-b from-night-900 via-night-800 to-earth-900 z-0" data-id="element-51"></div>
      <div className="absolute inset-0 bg-grain opacity-20 z-0 mix-blend-overlay" data-id="element-52"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-53">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1
      }} data-id="element-54">
          {/* Powerful, Professional Star */}
          <div className="flex justify-center mb-10" data-id="element-55">
            <RadiantStar size={96} animate={true} data-id="element-56" />
          </div>

          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-tight text-cream-50 mb-10 text-glow flex flex-col gap-2 md:gap-3" data-id="element-57">
            {phrases.map((phrase, index) => <motion.span key={index} initial={{
            opacity: 0,
            fontWeight: 300,
            filter: 'blur(4px)'
          }} animate={{
            opacity: 1,
            fontWeight: 400,
            filter: 'blur(0px)'
          }} transition={{
            duration: 1.2,
            delay: index * 0.3,
            ease: 'easeOut'
          }} className="block" data-id="element-58">
                {phrase}
              </motion.span>)}
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1.5,
          duration: 0.8
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-59">
            <Button variant="primary" href="#contact" data-id="element-60">
              Book a Session
            </Button>
            <Button variant="outline" href="#offerings" data-id="element-61">
              Discover Group Journeys
            </Button>
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom fade to blend with next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-earth-900 to-transparent z-10 pointer-events-none" data-id="element-62"></div>
    </section>;
}